function base64ToArrayBuffer(base64) {
  var binaryString =  window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++)        {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
  }
  return bytes;
}


var saveByteArray = (function () {
  var a = document.createElement("a");
  document.body.appendChild(a);
 // a.style = "display: none";
  return function (data, name) {


    
      var blob = new Blob(data, {type: "octet/stream"}),
          url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
  };
}());

export default function downloadPdf(fileName, data, isArrayBuffer) {
  let sampleBytes;
  if(isArrayBuffer){
    sampleBytes =data;
  } else {
    sampleBytes = base64ToArrayBuffer(data);
  }
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {

    var byteCharacters = atob(data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
      type: 'application/pdf'
    });

    window.navigator.msSaveOrOpenBlob(blob, fileName + ".pdf");
    return true;
  }

  if(isChrome){
    saveByteArray([sampleBytes], fileName + ".pdf");
    return true;
  }


  return false;
}
  
  
